import React from 'react';

export interface ScheduleStatusData {
  completed: number;
  missed: number;
  total: number;
  completedPercentage: number;
  missedPercentage: number;
}

export interface ScheduleStatusCardProps {
  data?: ScheduleStatusData | null;
  isEmpty?: boolean;
  className?: string;
}

const ScheduleStatusCard: React.FC<ScheduleStatusCardProps> = ({
  data,
  isEmpty = false,
  className = ""
}) => {
  const completed = data?.completed || 0;
  const missed = data?.missed || 0;
  const total = data?.total || 0;
  const completedPercentage = data?.completedPercentage || 0;
  const missedPercentage = data?.missedPercentage || 0;
  const allPercentage = total > 0 ? 100 : 0;

  return (
    <div className={`flex flex-col ${className}`}>
      {/* Progress Bars */}
      <div className="space-y-2 mb-3">
        {/* Completed Bar */}
        <div className="w-full">
          <div className="h-4 bg-gray-600 rounded-sm overflow-hidden relative">
            <div 
              className="h-full bg-green-500 transition-all duration-300 relative"
              style={{ 
                width: isEmpty ? '25px' : `${completedPercentage}%` 
              }}
            >
              {completedPercentage >= 10 && (
                <div className="absolute right-1 top-1/2 transform -translate-y-1/2 text-[8px] text-white font-bold">
                  ({completed}) {completedPercentage}%
                </div>
              )}
            </div>
            {completedPercentage < 10 && (
              <div className="absolute left-0 top-1/2 transform -translate-y-1/2 text-[8px] text-white font-bold" 
                   style={{ left: `${completedPercentage}%` }}>
                <span className="ml-2">({completed}) {completedPercentage}%</span>
              </div>
            )}
          </div>
        </div>

        {/* Missed Bar */}
        <div className="w-full">
          <div className="h-4 bg-gray-600 rounded-sm overflow-hidden relative">
            <div 
              className="h-full bg-red-500 transition-all duration-300 relative"
              style={{ 
                width: isEmpty ? '25px' : `${missedPercentage}%` 
              }}
            >
              {missedPercentage >= 10 && (
                <div className="absolute right-1 top-1/2 transform -translate-y-1/2 text-[8px] text-white font-bold">
                  ({missed}) {missedPercentage}%
                </div>
              )}
            </div>
            {missedPercentage < 10 && (
              <div className="absolute left-0 top-1/2 transform -translate-y-1/2 text-[8px] text-white font-bold" 
                   style={{ left: `${missedPercentage}%` }}>
                <span className="ml-2">({missed}) {missedPercentage}%</span>
              </div>
            )}
          </div>
        </div>

        {/* All Trainings Bar */}
        <div className="w-full">
          <div className="h-4 bg-gray-600 rounded-sm overflow-hidden relative">
            <div 
              className="h-full bg-white transition-all duration-300 relative"
              style={{ 
                width: isEmpty ? '25px' : `${allPercentage}%` 
              }}
            >
              {allPercentage >= 10 && (
                <div className="absolute right-1 top-1/2 transform -translate-y-1/2 text-[8px] text-black font-bold">
                  ({total}) {allPercentage}%
                </div>
              )}
            </div>
            {allPercentage < 10 && (
              <div className="absolute left-0 top-1/2 transform -translate-y-1/2 text-[8px] text-white font-bold" 
                   style={{ left: `${allPercentage}%` }}>
                <span className="ml-2">({total}) {allPercentage}%</span>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Legend */}
      <div className="flex flex-row gap-x-3">
        <div className="flex items-center space-x-1">
          <div className="w-2 h-2 bg-red-500 rounded-full"></div>
          <span className="text-[8px] text-white font-normal">Missed</span>
        </div>
        <div className="flex items-center space-x-1">
          <div className="w-2 h-2 bg-green-500 rounded-full"></div>
          <span className="text-[8px] text-white font-normal">Completed</span>
        </div>
        <div className="flex items-center space-x-1">
          <div className="w-2 h-2 bg-white rounded-full"></div>
          <span className="text-[8px] text-white font-normal">All Trainings</span>
        </div>
      </div>
    </div>
  );
};

export default ScheduleStatusCard;
